import script from "./DataStudio.vue?vue&type=script&setup=true&lang=js"
export * from "./DataStudio.vue?vue&type=script&setup=true&lang=js"

import "./DataStudio.vue?vue&type=style&index=0&id=6f95bbb7&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f95bbb7"]])

export default __exports__